import styles from "./HeaderTeam.module.scss";
import teamPicture from '../../../shared/assets/photo/Team/team.png';
import teamPicture_2x from '../../../shared/assets/photo/Team/team_2x.png';
import { Stack } from "../../../shared/ui/Stack/Stack";
import { Text } from "../../../shared/ui/Text/Text";
import teamPictureMob from '../../../shared/assets/photo/Team/teamMob.png';
import teamPictureMob_2x from '../../../shared/assets/photo/Team/teamMob_2x.png';

import gsap from 'gsap';
import { useGSAP } from '@gsap/react';


gsap.registerPlugin(useGSAP);


const HeaderTeam = () => {

    useGSAP(() => {
        gsap.fromTo(".team__header", {opacity: 0,  y:10,}, 
                                    { opacity: 1,
                                    y:0,  
                                    duration: 1, 
                                    });
    }, [])

    return ( 
        <div>
            <div className={styles.content}>
                <img className={styles.picture} src={teamPicture}
                        srcSet={`${teamPicture_2x} 2x`} alt="эстетическая стоматология" />
                <img className={styles.pictureMob} src={teamPictureMob}
                        srcSet={`${teamPictureMob_2x} 2x`} alt="эстетическая стоматология" />
            <Stack              
                justifyContent='justifyCenter'
                alignItems ='alignCenter'
                className={styles.header}>
                <Text
                    type='h1' 
                    size ='xxl'
                    className={`team__header ${styles.title}`}>
                        Наша команда
                </Text>
            </Stack>
            </div>
        </div>
    );
}
export default HeaderTeam;